module.exports = __webpack_public_path__ + "img/lpf_icon_bg_color.2a285b42.png";